import { defaultColumns, defaultSort } from '../../components/data/partners/columns';

export default {
  state: {
    partners: [],
    suppliers: [],
    customers: [],
    customersWithBillable: [],
    customersWithBillableLoading: false,
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    partners: state => state.partners,
    suppliers: state => state.suppliers,
    customers: state => state.customers,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
    customersWithBillable: state => state.customersWithBillable,
    customersWithBillableLoading: state => state.customersWithBillableLoading,
  },
  mutations: {
    setPartners(state, partners) {
      state.partners = partners;
    },
    setSuppliers(state, suppliers) {
      state.suppliers = suppliers;
    },
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCustomersWithBillable(state, customersWithBillable) {
      state.customersWithBillable = customersWithBillable;
    },
    setCustomersWithBillableLoading(state, customersWithBillableLoading) {
      state.customersWithBillableLoading = customersWithBillableLoading;
    }
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/partner-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'partner-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'partner-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const partners = await axios.get('api/partners' + (query || ''));
        commit('setPartners', partners);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchSuppliers({ commit }) {
      try {
        const suppliers = await axios.get('api/suppliers');
        commit('setSuppliers', suppliers);
      } catch (e) {}
    },

    async fetchCustomers({ commit }) {
      try {
        const customers = await axios.get('api/customers');
        commit('setCustomers', customers);
      } catch (e) {}
    },

    async fetchCustomersWithBillable() {
      return await axios.get('api/partners/customers/billable');
    },

    async fetchCustomersWithBillableWithPagination({ commit, state, dispatch }, {currentPage = 1, sorting = { prop: 'company.name', order: 'ascending' }}) {
      commit('setCustomersWithBillableLoading', true);
      const queryParams = `?page=${currentPage}&sortby=${sorting.prop}&sorttype=${sorting.order === 'ascending' ? 'asc' : 'desc'}`;
      try {
        const customersWithBillable = await axios.get('api/partners/customers/billable/paginated' + (queryParams || ''));
        commit('setCustomersWithBillable', customersWithBillable);
      } catch (e) {
      }
      commit('setCustomersWithBillableLoading', false);

    },

    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/partners/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async activeSearch({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/partners/active/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/partner-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Partners'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/partners/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/partners', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/partners', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/partners/${id}`);
    },
  },
};
